import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button } from "@/components/ui";
export const SessionWarningModal = ({ isOpen, timeRemaining, onContinue, onLogout })=>{
    if (!isOpen) return null;
    const formatTime = (seconds)=>{
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[9999]",
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative top-1/2 transform -translate-y-1/2 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center justify-center mb-4",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "flex-shrink-0",
                            children: /*#__PURE__*/ _jsx("svg", {
                                className: "h-12 w-12 text-yellow-500",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ _jsx("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        className: "text-lg font-semibold text-center text-gray-900 mb-2",
                        children: "Session Timeout Warning"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center mb-6",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-600 mb-2",
                                children: "Your session is about to expire due to inactivity."
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "text-lg font-bold text-red-600",
                                children: [
                                    "Time remaining: ",
                                    formatTime(timeRemaining)
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-600 mt-2",
                                children: "Would you like to continue your session?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-3 justify-center",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "simple",
                                buttonStyle: "flat",
                                onClick: onLogout,
                                className: "px-6",
                                children: "Logout Now"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "simple",
                                color: "navy-90",
                                onClick: onContinue,
                                className: "px-6",
                                children: "Continue Session"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
